// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bnqhkinpzawonoamoozf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJucWhraW5wemF3b25vYW1vb3pmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg1NjUyOTQsImV4cCI6MjA2NDE0MTI5NH0._rCXrlQH2RQRsCs8-S1b6Qw_iZjz8Mf4kFdwonMmrpM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);